<template>
<div class="chapter">
<div class="inner_page">
<p class="copy1">Editor: David Cashion<br/>Designer: Devin Grosz<br/>Production Manager: Kathleen Gaffney</p>
<p class="copy">Library of Congress Control Number: 2017930326</p>
<p class="copy">ISBN: 978-1-4197-2413-8<br/>eISBN: 978-1-6833-5047-7</p>
<p class="copy">Text copyright © 2017 Erin McHugh</p>
<p class="copy">Published in 2017 by Abrams Image, an imprint of ABRAMS. All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, mechanical, electronic, photocopying, recording, or otherwise, without written permission from the publisher.</p>
<p class="copy">Abrams books are available at special discounts when purchased in quantity for premiums and promotions as well as fundraising or educational use. Special editions can also be created to specification. For details, contact specialsales@abramsbooks.com or the address below.</p>
<p class="copy"><img alt="Images" height="62" src="images/copy.jpg" width="61"/><br/><strong>ABRAMS</strong> The Art of Books<br/>115 West 18th Street, New York, NY 10011<br/><a href="http://www.abramsbooks.com" target="_blank">abramsbooks.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?8a4503a2